import {Checkbox, Layout, Spacer} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {t} from '../../../localization';
import {
  TeamMember,
  useVehicleTypes,
  VehicleTypeLoader,
} from '../../../services';
import {MemberFieldEditor} from '../Components';

type Props = {
  member: TeamMember;
  disabled: boolean;
  onEditModeChanged: (t: boolean) => void;
};

export const DeliveryMethodsEditor: React.FC<Props> = ({
  member,
  disabled,
  onEditModeChanged,
}) => {
  const vehicleTypes = useVehicleTypes();

  const getFormattedValue = useCallback(
    (input?: Array<number>) =>
      !input || input.length === 0
        ? t('screens.member.fields.deliverymethods.empty')
        : input
            .map(id => vehicleTypes.find(vehicle => vehicle.id === id)?.name)
            .join(', '),
    [vehicleTypes],
  );

  const toggle = useCallback(
    (
      vehicleId: number | undefined,
      editState?: number[],
      p?: number[],
    ): number[] =>
      vehicleId === undefined || editState === undefined || p === undefined
        ? p ?? []
        : editState.find(id => id === vehicleId) === undefined
        ? // Add
          p.concat([vehicleId])
        : // Remove
          p.filter(id => id !== vehicleId),
    [],
  );

  return (
    <>
      <VehicleTypeLoader teamId={member?.teamId ?? -1} />
      <MemberFieldEditor
        entity={member}
        editKey="vehicleTypeIds"
        title={t('screens.member.fields.deliverymethods.title')}
        description={t('screens.member.fields.deliverymethods.description')}
        onGetDisplayValue={getFormattedValue}
        disabled={disabled}
        onEditModeChanged={onEditModeChanged}>
        {(editState, setEditState) =>
          vehicleTypes.map(vehicle => (
            <Layout key={vehicle.id} vertical>
              <Checkbox
                kind="Default"
                onPress={() =>
                  setEditState(p => toggle(vehicle.id, editState, p))
                }
                state={
                  editState?.find(id => id === vehicle.id) !== undefined
                    ? 'Checked'
                    : 'NotChecked'
                }
                label={vehicle.name}
              />
              <Spacer height="20" />
            </Layout>
          ))
        }
      </MemberFieldEditor>
    </>
  );
};
